import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import Icon from './icon';

export default function Button(props) {
    const {type='primary', to=null,  className='', submit=false, loading=false, children=null, ...restprops} = props;

    const btnprops = {
        ...restprops,
        className: classnames(className, 'btn', `btn-${type}`, {'btn-loading':loading}),
        type: submit ? 'submit' : 'button'
    };

    const loadingicon = loading && <Icon icon="spinner" spin={true} size="ss"/>;

    if (to) {
        return (
            <Link to={to} {...btnprops}>
                {loadingicon}
                {children}
            </Link>
        );
    }

    return (
        <button {...btnprops}>
            {loadingicon}
            {children}
        </button>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/button.js